import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { ReviewDialog } from "@/components/reviews/ReviewDialog";

const BOOKINGS_KEY = "svj_bookings";
const DISMISSED_KEY = "svj_review_dismissed";
const read = (k) => {
  try {
    return JSON.parse(localStorage.getItem(k)) || [];
  } catch {
    return [];
  }
};

export const rememberBooking = (id) => {
  const ids = read(BOOKINGS_KEY);
  if (!ids.includes(id)) localStorage.setItem(BOOKINGS_KEY, JSON.stringify([...ids, id].slice(-10)));
};

export const PostAppointmentReview = () => {
  const [booking, setBooking] = useState(null);

  useEffect(() => {
    const dismissed = read(DISMISSED_KEY);
    const ids = read(BOOKINGS_KEY).filter((id) => !dismissed.includes(id));
    if (!ids.length || window.location.pathname.startsWith("/booking/") || window.location.pathname.startsWith("/admin")) {
      return;
    }
    Promise.all(ids.map((id) => api.get(`/bookings/${id}`).then((r) => r.data).catch(() => null))).then((list) => {
      const due = list.find((b) => b && b.status === "completed" && !b.reviewed);
      if (due) setBooking(due);
    });
  }, []);

  const close = (open) => {
    if (!open && booking) {
      localStorage.setItem(DISMISSED_KEY, JSON.stringify([...read(DISMISSED_KEY), booking.id]));
      setBooking(null);
    }
  };

  return <ReviewDialog open={!!booking} onOpenChange={close} bookingId={booking?.id} defaultName={booking?.name || ""} />;
};
